import { trackPromise } from 'react-promise-tracker';
import { fetchWithAuth } from './fetchWithAuth';

export async function getCandidates(campaignId, cif, userToken) {
    return trackPromise(
        fetchWithAuth(
            'https://t41bx8uqf6.execute-api.us-east-2.amazonaws.com/prod/votacion/candidato',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorizationToken': userToken
                },
                body: JSON.stringify({
                    IDCampana: campaignId,
                    CIF: cif
                })
            }
        )
    );
}
